import React from 'react';
import { ExclamationTriangleIcon } from '@heroicons/react/24/outline';
import LegalDocument from '../components/LegalDocument';
import { riskDisclosureContent } from '../content/riskDisclosure';

const RiskDisclosurePage = () => {
  return <LegalDocument content={riskDisclosureContent} icon={ExclamationTriangleIcon} />;
};

export default RiskDisclosurePage;
